/**
 *
 * @prettier
 * @author Brook Worku
 * @since
 *
 * action to invoke ffps reducer to update ffps user details
 */
import { getCookieValue } from 'app/actions/genericActionCreator'
import { UserInformation } from '../../settings/types/FfpsUserDetailsTypes'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { SubmissionError, reset } from 'redux-form'
import { convertLgyErrorResponseToFormErrorObject } from 'app/utils/formUtils'
import { Dispatch } from 'redux'

const updatingFfpsUserInfo = ({
  ffpsUserFirstName,
  ffpsUserLastName,
  ffpsUserEmail,
  ffpsUsername,
  ffpsAffiliated
}: UserInformation) => ({
  type: 'UPDATE_FFPS_USER_DETAILS',
  ffpsUserFirstName,
  ffpsUserLastName,
  ffpsUserEmail,
  ffpsUsername,
  ffpsAffiliated
})

const fetchingFfpsUserInfo = () => ({
  type: 'FETCHING_FFPS_USER_DETAILS'
})

const errorFetchingFfpsUser = (errorMsg: string) => ({
  type: 'ERROR_FETCHING_FFPS_USER',
  errorMsg
})

export const resetFfpsUserDetailAction = () => (dispatch: Dispatch) => {
  dispatch({
    type: 'RESET_FFPS_USER_DETAILS'
  })
  dispatch(reset('fetchFfpsUserDetails'))
}

export const fetchFfpsUserInfo = (userName: string, vaEauthSecId: string) => async (dispatch: Dispatch) => {
  const ffpsUserName = userName.toLowerCase()
  let reqHeaders: HeadersInit = new Headers()
  reqHeaders.set('Content-Type', 'application/json')
  reqHeaders.set('X-XSRF-TOKEN', getCookieValue('XSRF-TOKEN') as string)
  dispatch(fetchingFfpsUserInfo())

  try {
    const response = await fetch('/lgyhub/api/users/ffps', {
      credentials: 'include',
      method: 'POST',
      headers: reqHeaders,
      body: JSON.stringify({ ffpsUserName, vaEauthSecId })
    })
    const data = await catchCommonErrors(dispatch, response, 'FFPS User Info')

    if (data.status >= 400) {
      dispatch(errorFetchingFfpsUser(data.errors[0].message))
      throw new SubmissionError(convertLgyErrorResponseToFormErrorObject(data))
    } else {
      dispatch(updatingFfpsUserInfo(data))
    }
  } catch (error) {
    console.error(error)
  }
}
